import Badge from "@/components/core/badge";
import {
	Blanket,
	BlanketImage,
	BlanketInfo,
} from "@/components/core/blanket.tsx";
import type { CaseRecord } from "@/features/case-record/types/case-records";
import { formatDate } from "@/utils/format-date";
import {
	IconCancel,
	IconCircleDot,
	IconDatabaseExclamation,
	IconGavel,
	IconProgress,
} from "@tabler/icons-react";
import { Link } from "@tanstack/react-router";

export const ProfileCaseList = ({ cases }: { cases: CaseRecord[] | [] }) => {
	const CaseItem = ({ caseItem }: { caseItem: CaseRecord }) => {
		return (
			<div className="relative flex flex-col w-full gap-2">
				<div className="absolute right-full -top-1 mr-2 inline-flex w-[32px] h-[32px] rounded-full justify-center items-center bg-background text-primary-600">
					<IconCircleDot size={18} stroke={2} />
				</div>
				<div className="flex flex-row items-center w-full gap-2">
					<Link
						to="/"
						className="text-base font-semibold text-blue-600 hover:text-blue-500 truncate"
					>
						Case No. {caseItem.case_number}
					</Link>
					{caseItem.status === "draft" ? (
						<Badge className="uppercase" size="xs" color="yellow">
							DRAFT
						</Badge>
					) : caseItem.status === "branch_receiving" ? (
						<Badge className="uppercase" size="xs" color="yellow">
							PENDING
						</Badge>
					) : (
						<Badge
							className="uppercase"
							size="xs"
							color={caseItem.status === "CASE_CLOSED" ? "gray" : "green-light"}
						>
							{caseItem.stage ? caseItem.stage : caseItem.status}
						</Badge>
					)}
				</div>
				<div className="flex flex-col w-full rounded-md p-4 border border-border/50">
					<div className="inline-flex flex-col w-auto">
						<span className="text-base font-bold text-foreground-dark">
							{caseItem.case_title}
						</span>
						<span className="text-base text-foreground">
							Case filed {formatDate(caseItem.filed_at, "PP")}
						</span>
						<span className="text-base text-foreground">{caseItem.branch}</span>
						<span className="text-base text-foreground truncate">
							{caseItem.case_category} - {caseItem.case_type}
						</span>

						<span className="text-base text-foreground">
							Party Type: <span>{caseItem.party_type}</span>
						</span>
					</div>
				</div>
			</div>
		);
	};

	return (
		<div className="flex flex-col w-full mt-6">
			{cases?.length ? (
				<div className="flex flex-col w-full pl-3">
					<div className="flex flex-col w-full pl-6 gap-6 border-l border-border/50">
						{cases.map((item) => (
							<CaseItem caseItem={item} key={item.id} />
						))}
					</div>
				</div>
			) : (
				<div className="flex flex-col w-full rounded-md border border-border/50">
					<Blanket width="sm">
						<BlanketImage
							icon={<IconDatabaseExclamation size={24} stroke={1.5} />}
						/>
						<BlanketInfo
							title="No Data"
							message="No available data for now. Please check back later or refresh the page."
						/>
					</Blanket>
				</div>
			)}
		</div>
	);
};
